export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/ob-step-1.png?9b8ba7c08a2ea4a3dc77049a637c6d4a";